<template>
  <el-row align="middle" justify="center">
    <el-col :span="12" :offset="6">
      <div class="goship-logo">
        <img src="../../../static/logo-green.png" width="200" alt="1Express">
        <p>Nền tảng chuyển phát dành cho thương mại điện tử</p>
      </div>
      <div class="login-box">
        <h2 class="text-center"><i class="fa fa-key" aria-hidden="true"></i> Đăng nhập</h2>
        <p class="text-center">Chào mừng bạn trở lại!</p>
        <el-form :rules="rules" ref="loginForm" :model="login" label-width="120px" @submit.prevent.native="validateBeforeSubmit" label-position="top">
          <el-form-item prop="username" class="padding-login-item">
            <el-input v-model="login.username" placeholder="Email"></el-input>
          </el-form-item>
          <el-form-item prop="password" class="padding-login-item">
            <el-input type="password" v-model="login.password" placeholder="Mật khẩu"></el-input>
          </el-form-item>
          <!-- <el-form-item label="Nhập lại mật khẩu" prop="re_password">
            <el-input type="password" v-model="login.re_password"></el-input>
          </el-form-item> -->
          <el-form-item class="padding-login-item">
            <el-button type="primary" :disabled="submitting" native-type="submit" class="width-100">Đăng nhập</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-col>
  </el-row>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import { login } from '../../api/accounts'
  import { head } from 'lodash'
  export default {
    name: 'Login',
    computed: {
      ...mapState({
        login: state => state.account.login
      }),
      ...mapGetters(['isLogged'])
    },
    data () {
      // let comfirmPass = (rule, value, callback) => {
      //   if (value !== this.login.password) {
      //     callback(new Error('Nhập lại mật khẩu không đúng'))
      //   } else {
      //     callback()
      //   }
      // }
      return {
        rules: {
          username: [{
            required: true,
            message: 'Email không được để trống',
            trigger: 'change'
          }, {
            type: 'email',
            message: 'Email không hợp lệ',
            trigger: 'change'
          }],
          password: [{
            required: true,
            message: 'Mật khẩu không được để trống',
            trigger: 'change'
          }, {
            min: 6,
            message: 'Mật khẩu cần ít nhất 6 ký tự',
            trigger: 'change'
          }]
          // re_password: [{
          //   required: true,
          //   message: 'Mật khẩu không được để trống',
          //   trigger: 'change'
          // }, {
          //   validator: comfirmPass,
          //   trigger: 'change'
          // }]
        },
        submitting: false
      }
    },
    methods: {
      validateBeforeSubmit () {
        this.submitting = true
        this.$refs.loginForm.validate(valid => {
          if (valid) {
            login(this.login).then(response => {
              if (response.code === 200) {
                this.$store.dispatch('showNotify', {
                  title: 'Đăng nhập thành công',
                  body: 'Đăng nhập thành công'
                })
                this.$store.dispatch('logged', response)
                this.$router.push({path: '/'})
                this.submitting = false
              }
              if (response.code === 422) {
                let er = response.data.errors
                let message = head(er)
                this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: message,
                  type: 'warning'
                })
                this.submitting = false
              }
            })
          } else {
            this.$store.dispatch('showNotify', {
              title: 'Vui lòng kiểm tra thông tin cần nhập',
              type: 'warning'
            })
            this.submitting = false
            return false
          }
        })
      }
    },
    mounted () {
      if (this.isLogged) {
        this.$router.push({path: '/'})
      }
    }
  }
</script>

<style lang="css" scoped>
.login-box {
  position: absolute;
  margin: 10px auto;
  width: 500px;
  background: #fff;
  padding: 10px;
  border-radius: 10px;
  left: 50%;
  top: 140px;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  text-align: center;
}
.goship-logo {
  margin: 30px 0;
  text-align: center;
}
.padding-login-item {
  padding: 0 100px;
}
</style>



// WEBPACK FOOTER //
// Login.vue?61b6878e